module.exports = __webpack_public_path__ + "img/MaskGroup 2882.daf720b3.svg";